import TimelineStep from 'src/components/ui/TimelineStep/TimelineStep';
import React from 'react';

interface TimelineProps {
  steps: {
    title: string;
    datetime: string;
    state: 'completed' | 'pending' | 'failed';
  }[];
}

const Timeline: React.FC<TimelineProps> = ({ steps }) => {
  return (
    <div className="px-20 pb-20">
      <div className="flex flex-col gap-24">
        {steps.map((step, index) => (
          <TimelineStep
            key={step.title}
            title={step.title}
            datetime={step.datetime}
            state={step.state}
            isLastStep={index === steps.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default Timeline;
